import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeftLong } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import SymptomsTable from "./SymptomsTable";
import React, {useContext} from "react";
import InitContext from "../pages/InitContext";

const Symptoms = () => {
  const { t: t } = useTranslation();
  const context = useContext(InitContext);

  return (
    <div className="w3-display-container content-container">
      <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
        <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
      </div>
      <div className="w3-display-middle form-display ">
        <div className="w3-panel w3-card-4 record-panel ">
          <SymptomsTable>
            <h2>{t("symptoms")}</h2>
          </SymptomsTable>
          <footer className="w3-container w3-center w3-padding-small">
            <div className="w3-left w3-padding-small">
              <button className="w3-btn w3-round-xlarge w3-theme-d5">
                <NavLink to={`/diary/`} className="home-label">
                  <FontAwesomeIcon icon={faLeftLong} /> {t("to_your_diary")}
                </NavLink>
              </button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Symptoms;
